import { useTableContext } from "@/common/contexts/Table.context";
import NexPaginationButton from "@/components/Pagination/NexPaginationButton";
import PaginationButton from "@/components/Pagination/PaginationButton";
import PreviousPaginationButton from "@/components/Pagination/PreviousPaginationButton";
import { Pagination } from "antd";
import QuoteList from "../QuotesTable/QuoteList";
import { useGetMeCompletedQuotes } from "@/common/api/queries";
import DownloadQuotesButton from "../DownloadQuotesButton/DownloadQuotesButton";
import { ResetFiltersButton } from "@/components";

export default function VendorsQuotes() {
  const { changePage, currentPage, filters, searchQ } = useTableContext();
  const { data } = useGetMeCompletedQuotes(currentPage * 10, filters, searchQ);
  return (
    <div className="w-full">
      <div className="flex justify-end">
        <ResetFiltersButton />
      </div>
      <div className="w-full">
        <QuoteList data={data?.items} />
      </div>
      <div className="flex justify-between items-center mt-5">
        <div className="w-1/6"></div>
        {Boolean(data && data?.total > 10) && (
          <>
            <Pagination
              onChange={changePage}
              current={currentPage + 1}
              total={data?.total || 1}
              defaultPageSize={10}
              pageSize={10}
              align="center"
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                switch (type) {
                  case "next":
                    return <NexPaginationButton />;
                  case "prev":
                    return <PreviousPaginationButton />;
                  case "page":
                    return (
                      <PaginationButton current={currentPage + 1} page={page} />
                    );
                  default:
                    return originalElement;
                }
              }}
            />
            <DownloadQuotesButton />
          </>
        )}
      </div>
      {Boolean(data?.total && data?.total < 10) && (
        <div className="justify-self-end">
          <DownloadQuotesButton />
        </div>
      )}
    </div>
  );
}
